module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA4AAAARCAYAAADtyJ2fAAAAAXNSR0IArs4c6QAAAFhJREFUKBVjZMAE/zGFwCKMyOJMyBxS2CNFYwMwUEAhCcO4wggmD6IbYIpADGQJfGy4JlI0Y2giRjNOTfg0E9SETTPRmpA1k6wJppn6NCirgOKMZEB27gAAE5As7DJgK2gAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/images/material-icons-black-download.png
// module id = 964
// module chunks = 0